import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_025.jpg';
page.images = [
  {
    imageId: 'page025_zoom0',
    rectangle: {
      x: 600,
      y: 1524,
      width: 1182,
      height: 750,
    },
    imageSrc: 'images/page025/025 1.jpg',
  },
  {
    imageId: 'page025_zoom1',
    rectangle: {
      x: 226,
      y: 222 + 70,
      width: 1558,
      height: 802 - 70,
    },
    imageSrc: 'images/page025/025 2.jpg',
  },
];
page.games = [
  {
    id: 'page025_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1533,
    },
    item: {
      id: 'page025_game10',
    },
    rectangle: {
      id: 'page025_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page025_rect0',

    tooltip: '',

    linked: ['page025_game10'],
    x: 129,
    y: 1533,
    width: 460,
    height: 368,
  },
];
export default page;
